import React from 'react';

const Dashboard: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d={`M13.998 3.38086C14.971 3.38089 15.7513 3.65975 16.2881
      4.19824C16.8249 4.73669 17.0986 5.5153 17.0986 6.47559V11.3477C17.0986
      12.3076 16.8246 13.0857 16.2881 13.624C15.7513 14.1625 14.971 14.4414
      13.998 14.4414H10.2568L8.14551 16.3125C7.71775 16.6899 7.41627 16.8965
      7.00391 16.8965C6.71661 16.8964 6.47383 16.7959 6.30469 16.6025C6.13774
      16.4116 6.05664 16.1462 6.05664 15.8418V14.4414H5.94922C5.00947 14.4413
      4.24074 14.1619 3.70703 13.624C3.17355 13.0862 2.89266 12.3086 2.89258
      11.3477V6.47559C2.89258 5.51536 3.16643 4.73668 3.70312 4.19824C4.2399
      3.65979 5.02029 3.38094 5.99316 3.38086H13.998ZM6.02539 4.91211C5.45566
      4.91211 5.06297 5.05491 4.81152 5.30957C4.55972 5.56479 4.42383 5.95841
      4.42383 6.51367V11.3096C4.42383 11.8648 4.55972 12.2575 4.81152 12.5127C5.06296
      12.7675 5.45545 12.9111 6.02539 12.9111H6.79688C6.99107 12.9111 7.16852
      12.9492 7.29395 13.0723C7.41996 13.1959 7.46191 13.3742 7.46191
      13.5762V15.0068L9.19629 13.293C9.33523 13.1479 9.46555 13.048 9.61914
      12.9873C9.7723 12.9269 9.93593 12.9111 10.1309 12.9111H13.96C14.5299
      12.9111 14.9247 12.7678 15.1777 12.5127C15.4309 12.2573 15.5684 11.8643
      15.5684 11.3096V6.51367C15.5684 5.95882 15.431 5.56492 15.1777 5.30957C14.9247
      5.05452 14.5298 4.91211 13.96 4.91211H6.02539ZM10.0088 5.93457C10.2009 5.93457
      10.3716 6.06522 10.4424 6.27734L10.4434 6.2793L10.9062 7.71973H12.4658C12.6887
      7.71973 12.8673 7.83731 12.9248 8.02246C12.9747 8.18348 12.9208 8.35609 12.7861
      8.48438L12.7236 8.53711L11.4619 9.44531L11.9434 10.8916H11.9424C12.0203 11.1188
      11.9696 11.3346 11.8008 11.4482C11.6384 11.5573 11.42 11.5347 11.2461
      11.4053V11.4043L10.0107 10.4971L8.77539 11.4053V11.4062C8.59796 11.5353
      8.37904 11.5548 8.2168 11.4453C8.06899 11.3455 8.00998 11.1681 8.05078
      10.9736L8.07422 10.8896L8.55859 9.44531L7.29395 8.53711C7.11054 8.4065
      7.03168 8.20703 7.08887 8.02246C7.14609 7.83818 7.32347 7.71983 7.54395
      7.71973H9.11133L9.58008 6.2793C9.64728 6.06613 9.81626 5.9347 10.0088
      5.93457Z`} fill={props?.fill} stroke={props?.fill} stroke-width="0.3"/>
  </svg>
);

export default Dashboard;
